import React from 'react';
import {Provider} from 'react-redux';
import {appStore} from '../../../../store/configureStore';

export interface StoreProviderProps {
  children: React.ReactNode;
}

/** Should be placed on the top level of the application tree */
const StoreProvider = ({children}: StoreProviderProps) => {
  return (
    <Provider store={appStore}>
      {children}
    </Provider>
  );
};

export default StoreProvider;
